module.exports = __webpack_public_path__ + "static/img/IMG_20150310_164821.1adc758a.jpg";